import apiUtil from "../../../util/apiUtil";
import {ILoginResponse} from "./authModels";

// functions here should use fetch to request data from the api
// and return objects that are defined in authModels.ts
const authApi = {
    // Demo auth: check if the Identity cookie is still valid and return the login response.
    authenticateViaIdentity(): Promise<ILoginResponse> {
        return apiUtil.fetchData<ILoginResponse>("/api/account/me");
    },

    // Demo auth: sign in with email/password and receive the full login response.
    loginWithCredentials(email: string, password: string): Promise<ILoginResponse> {
        return apiUtil.postData("/api/account/login", {email, password});
    },

    // Demo auth: sign out and invalidate the Identity cookie.
    logout(): Promise<void> {
        return apiUtil.postData("/api/account/logout", {});
    }
};

export default authApi;
